import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { loadScript } from '../utils'

export default function AWSWAFCaptchaModal() {
  useEffect(() => loadScript())

  return createPortal(
    <div
      className="fixed top-0 left-0 w-full h-full bg-black/30 z-50 hidden"
      id="modalOverlay"
    >
      <div
        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded p-4"
        id="modal"
      >
        <div id="captchaForm" />
      </div>
    </div>,
    document.body
  )
}
